var React = require('react');

function BoxLogo (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.box-logo{fill:#FFFFFF;}\n"),React.createElement("g",{"key":1},[React.createElement("path",{"className":"box-logo","d":"M0,10.4v4.8c2-0.8,4.2-1.5,6.3-1.8C6.3,13.4,3.9,10.7,0,10.4z","key":0}),React.createElement("path",{"className":"box-logo","d":"M4.9,10.1c3.4,1.8,5,2.9,8.3,2.9c0,0,6.5,0.1,10.4-2.7c0,0-2.8,3.8-8.2,5.1c1.4,0.7,6.6,2.6,11.6,3.3\n\t\tc1.7,0.2,3.4,0.2,4.9,0V0H0v9.3C1.5,9,3.2,9.2,4.9,10.1z","key":1}),React.createElement("path",{"className":"box-logo","d":"M25.9,22.8c-7.1-0.2-11.9-5-18.5-6.4c-2.3-0.5-5-0.2-7.4,0.3V32h32V21.5C30.2,22.3,28.2,22.9,25.9,22.8z","key":2})])]);
}

BoxLogo.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 32 32","style":{"enableBackground":"new 0 0 32 32"},"xmlSpace":"preserve"};

module.exports = BoxLogo;

BoxLogo.default = BoxLogo;



//////////////////
// WEBPACK FOOTER
// ./src/img/svg/box-logo.svg
// module id = 395
// module chunks = 114276838955818